import React from 'react';
import styled from 'styled-components';

const StyledButton = styled.button`
  padding: 8px 16px;
  border: ${props => props.$variant === 'outline' ? '1px solid #e87225' : 'none'};
  border-radius: 8px;
  background-color: ${props => props.$variant === 'outline' ? 'transparent' : '#e87225'};
  color: ${props => props.$variant === 'outline' ? '#e87225' : 'white'};
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s;
  display: flex;
  align-items: center;
  gap: 8px;

  &:hover {
    background-color: ${props => props.$variant === 'outline' ? '#fff5f0' : '#d65c11'};
    transform: translateY(-1px);
    box-shadow: 0 4px 12px rgba(232, 114, 37, 0.2);
  }

  &:active {
    transform: translateY(0);
  }

  &:disabled {
    background-color: #ccc;
    border-color: #ccc;
    cursor: not-allowed;
    transform: none;
    box-shadow: none;
  }

  svg {
    width: 18px;
    height: 18px;
  }
`;

const Button = ({ children, variant, ...props }) => (
  <StyledButton $variant={variant} {...props}>
    {children}
  </StyledButton>
);

export default Button; 